import { render, staticRenderFns } from "./ModalUnsubscribeUserFromReport.vue?vue&type=template&id=37c81610&scoped=true"
import script from "./ModalUnsubscribeUserFromReport.vue?vue&type=script&lang=js"
export * from "./ModalUnsubscribeUserFromReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c81610",
  null
  
)

export default component.exports